import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'

import { Col, Row, Typography } from 'antd'
import styled from 'styled-components'
import { colours } from '@qflow/theme'

import { ColourButton, Flex } from 'portal/lib/primitives'

import { Alerts, Delivery, Utilities, Waste } from './sections'

export const Home = ({ startDate, endDate }) => {
  const auth = useSelector((state: any) => state.auth)

  const { accountId, projectId } = useParams<{
    accountId: string
    projectId: string
  }>()
  const { Title } = Typography

  return (
    <>
      <Flex.Row
        style={{
          width: '99.9%',
          alignItems: 'baseline',
          flex: '0 0 auto',
          marginBottom: '1.5rem'
        }}
      >
        <Title level={2} id="Heading" style={{ marginBottom: '0' }}>
          Welcome, {auth.userId}
        </Title>
      </Flex.Row>

      <Row gutter={[16, 16]}>
        <Col span={12}>
          <Section>
            <Delivery />
          </Section>
        </Col>
        <Col span={12}>
          <Section>
            <Waste />
          </Section>
        </Col>
        {/*
        <Col span={24}>
          <Section>
            <Alerts />
          </Section>
        </Col>
        <Col span={12}>
          <Section>
            <Utilities />
          </Section>
        </Col> */}
      </Row>
    </>
  )
}

const Section = styled.div`
  background-color: ${colours.WHITE};
  border-radius: 0.625rem;
  padding: 1rem 1.125rem;
  box-shadow: 0px 1px 3px 0px #00000026;
`
